import React from 'react';
import { useTranslation } from 'react-i18next';

/**
 * Bestätigungsdialog zum Entfernen der Lizenz (Demo-Modus).
 */
function RemoveLicenseDialog({ open, onConfirm, onCancel }) {
  const { t } = useTranslation();
  if (!open) return null;

  return (
    <div className="edit-overlay" onClick={onCancel}>
      <div className="edit-modal" onClick={(e) => e.stopPropagation()}>
        <div className="edit-header">
          <h3>{t('dialog.license_remove.title')}</h3>
          <button className="btn-close" onClick={onCancel} type="button">×</button>
        </div>
        <div className="edit-content">
          <p style={{ fontSize: '1rem', color: '#374151', lineHeight: '1.6' }}>
            {t('dialog.license_remove.confirm')}
          </p>
          <div className="edit-info">
            <div style={{ marginTop: '8px', fontSize: '0.9rem', color: '#6b7280' }}>
              {t('dialog.license_remove.demo_info')}
            </div>
          </div>
        </div>
        <div className="edit-actions">
          <button className="btn btn-danger" onClick={onConfirm} type="button">
            {t('dialog.remove')}
          </button>
          <button className="btn btn-secondary" onClick={onCancel} type="button">
            {t('dialog.cancel')}
          </button>
        </div>
      </div>
    </div>
  );
}

export default RemoveLicenseDialog;
